import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Membro } from 'src/app/modules/_models/membro';
import { FieldConfig } from 'src/app/modules/_models/field.interface';
import { ValidacaoService } from 'src/app/modules/_services/validacao.service';
import { FidelidadeService } from 'src/app/modules/_services/fidelidade.service';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/modules/_services/auth.service';

export interface Mensagem {
  mensagem: string;
  remetente: Remetente;
}

export enum Remetente {
  usuario = 1,
  bot = 2,
}

@Component({
  selector: 'app-cadastro-chat',
  templateUrl: './cadastro-chat.component.html',
  styleUrls: ['./cadastro-chat.component.scss'],
})
export class CadastroChatComponent implements OnInit {
  cacauLoverCadastro: Membro = new Membro();

  regConfigCadastroCacauLover: FieldConfig[];
  regConfigCadastroCacauLoverFooter: FieldConfig[];
  regConfigCadastroCacauLoverTermos: FieldConfig[];
  regConfigCadastroCacauLoverFinalizar: FieldConfig[];

  regConfigCadastroLoverCamposRodape: FieldConfig[];

  chatMensagens: Mensagem[] = [];
  indexChat: number = 1;
  indexChatBot: number = 0;

  exibePopupChatLover: boolean = false;

  membro: Membro = new Membro();

  etapaAtual: number = 1;

  chatMensagensBot: Mensagem[] = [
    {
      mensagem: 'Vamos fazer agora o seu cadastro, é super rápido.',
      remetente: 2,
    },
    { mensagem: 'Qual é o seu CPF?', remetente: 2 },
    {
      mensagem:
        'Com essas informações podemos oferecer muitas coisas legais para você.',
      remetente: 2,
    },
    { mensagem: 'Qual é o seu nome completo?', remetente: 2 },
    { mensagem: 'Legal, {NOME}.', remetente: 2 },
    {
      mensagem: 'Legal, agora me fala qual o número do seu celular.',
      remetente: 2,
    },
    { mensagem: 'E sua data de nascimento?', remetente: 2 },
    { mensagem: 'Agora preciso que informe o seu e-mail.', remetente: 2 },
    {
      mensagem: 'Agora é necessário aceitar os termos e condições do programa',
      remetente: 2,
    },
    {
      mensagem:
        'Cadastro concluído! Você já pode aproveitar os descontos na loja!',
      remetente: 2,
    },
  ];
  chatMensagensBotErro: Mensagem[] = [
    { mensagem: 'O CPF informado não é válido.', remetente: 2 },
    { mensagem: 'Certifique se informou o nome corretamente.', remetente: 2 },
    {
      mensagem: 'O número informado não é válido, tente novamente.',
      remetente: 2,
    },
    {
      mensagem: 'A data de nascimento informada não é válida, tente novamente.',
      remetente: 2,
    },
    {
      mensagem: 'A senha não cumpre os requisitos, tente outra.',
      remetente: 2,
    },
    {
      mensagem: 'É necessário aceitar os termos para se tornar um Cacau Lover.',
      remetente: 2,
    },
    {
      mensagem: 'O nome deve conter apenas letras.',
      remetente: 2,
    },
    {
      mensagem:
        'A senha deve cumprir os requisitos sendo: tamanho minimo de 8 caracteres, letras maiúsculas e minúsculas, número e caractere especial.',
      remetente: 2,
    },
    {
      mensagem:
        'Infelizmente não foi possível realizar, tente novamente mais tarde.',
      remetente: 2,
    },
    {
      mensagem: 'O e-mail informado não é válido, tente novamente.',
      remetente: 2,
    },
    {
      mensagem: 'Digite alguma coisa antes de tentar enviar.',
      remetente: 2,
    },
    {
      mensagem: 'Já existe um cadastro com o CPF informado.',
      remetente: 2,
    },
    {
      mensagem:
        'Apenas pessoas maiores de 18 anos podem participar do programa!',
      remetente: 2,
    },
    {
      mensagem:
        'O e-mail informado para o cadastro já está sendo utilizado por outro Lover!',
      remetente: 2,
    },
  ];

  regConfigChatIcon: FieldConfig[] = [];

  @ViewChild('chatScroll') private chatScroll: ElementRef;

  exibirLoaderFullscreen: boolean = false;

  constructor(
    private validacao: ValidacaoService,
    private fidelidadeService: FidelidadeService,
    private router: Router,
    private AuthService: AuthService
  ) {}

  ngOnInit(): void {
    const self = this;

    this.regConfigChatIcon = [
      {
        type: 'image',
        src: 'assets/images/others/selo_chat_cacaulovers.png',
        style(): object {
          return {
            height: '80px',
          };
        },
        onClick(): void {
          self.carregarChatCadastro();
        },
      },
    ];
  }

  carregarChatCadastro() {
    var self = this;

    this.regConfigCadastroCacauLover = [
      {
        type: 'input',
        inputType: 'text',
        inputmode: 'numeric',
        label: 'Digite seu CPF aqui',
        mask: '000.000.000-00',
        name: 'chat',
        value: '',
        mainIcon: 'fa-paper-plane',
        style(): object {
          return {
            width: '90%',
            height: '40px',
            'font-size': '12px',
            'padding-left': '10px',
            'margin-left': 'calc(7% - 15px)',
            'font-weight': 'bold',
            'font-family': 'Sagona',
            'border-radius': '1rem 0 1rem 1rem',
            'text-align': 'left',
            'background-color': '#E8DFCA !important',
            background: '#E8DFCA !important',
            border: '0',
            outline: 'none',
            'margin-bottom': '-35px',
          };
        },
        styleIcon(): object {
          return {
            'font-size': '20px',
            position: 'fixed',
            right: '4rem',
            margin: '23px -20px',
            color: '#461F1A',
          };
        },
        styleDivPrincipal(): object {
          return {
            'width:': '100%',
            display: 'block',
            margin: '10px 0px',
          };
        },
        onClickIcon() {
          self.prosseguirChat();
        },
      },
    ];

    this.regConfigCadastroCacauLoverTermos = [
      {
        type: 'checkbox',
        label:
          'Li e aceito os termos javascript:abrirFecharPopupTermos(this,true) e condições javascript:abrirFecharPopupRegulamento(this,true) do programa Cacau Lovers',
        name: 'aceitaTermosChat',
        value: false,
        style(): object {
          return {
            'font-family': 'Sagona',
            'font-style': 'normal',
            'font-weight': '400',
            'font-size': '12px',
            width: '80%',
            display: 'block',
            margin: 'auto',
            'line-height': '11px',
            'text-align': 'left',
          };
        },
      },
    ];

    this.regConfigCadastroCacauLoverFinalizar = [
      {
        type: 'button',
        label: 'Finalizar seu cadastro.',
        style(): object {
          return {
            width: '75%',
            'background-color': 'rgb(70, 31, 26)',
            color: 'rgb(244, 178, 65)',
            display: 'block',
            'margin-left': 'auto',
            'margin-right': '10px',
            'border-radius': '1rem 0 1rem 1rem',
          };
        },
        onClick: () => {
          self.prosseguirChat();
        },
      },
    ];

    this.regConfigCadastroCacauLoverFooter = [
      {
        type: 'slider',
        name: 'sliderCadastroLover',
        visible: true,
        value: this.indexChat,
        maxSize: 6,
        disabled: true,
        style(): object {
          return {
            width: '85%',
            display: 'block',
            margin: 'auto',
          };
        },
      },
    ];

    this.chatMensagens = [];
    this.regConfigCadastroCacauLover[0].value = '';
    this.indexChatBot = 0;
    this.indexChat = 1;
    this.regConfigCadastroCacauLoverFooter[0].value = this.indexChat;

    this.exibePopupChatLover = true;
    this.exibirMensagemChat(2);
  }

  prosseguirChat() {
    if (this.indexChat == 7) return;

    if (this.indexChat != 6) {
      var chat = this.regConfigCadastroCacauLover[0];
      var dado = chat.value;

      var chatMensagem = (<HTMLInputElement>document.getElementById('chat'))
        .value;
      if (!chatMensagem) {
        if (this.indexChat != 5) {
          // this.chatMensagens.push(this.chatMensagensBotErro[10]);
          this.irParaOFimDoChat();
          return;
        }
      }
    }

    if (this.indexChat == 6) {
      chatMensagem = '';
      // for (var i = 0; i < dado.length; i++) {
      //     chatMensagem += '*';
      // }
    }
    var mensagem: Mensagem = {
      mensagem: chatMensagem,
      remetente: 1,
    };

    if (this.indexChat != 6) this.chatMensagens.push(mensagem);

    switch (this.indexChat) {
      case 1:
        if (!this.validacao.validarCPF(dado)) {
          this.chatMensagens.push(this.chatMensagensBotErro[0]);
          this.irParaOFimDoChat();
          chat.value = '';
          return;
        }

        this.exibirLoaderFullscreen = true;
        this.fidelidadeService.verificarSeJaEstaCadastrado(dado).subscribe(
          (res) => {
            if (res.message === 'CacauLover - Cliente cadastrado na base!') {
              this.chatMensagens.push(this.chatMensagensBotErro[11]);
              this.irParaOFimDoChat();

              chat.value = '';

              this.regConfigCadastroCacauLover = [];
              // this.regConfigCadastroCacauLoverFooter = [];

              this.indexChat = 7;
              this.regConfigCadastroCacauLoverFooter[0].value = this.indexChat;

              this.regConfigCadastroCacauLoverFinalizar[0].label =
                'Faça seu login e aproveite';
              this.regConfigCadastroCacauLoverFinalizar[0].onClick = () =>
                this.router.navigate(['/home', 'login']);

              this.exibirLoaderFullscreen = false;
            } else {
              this.cacauLoverCadastro.cpf = dado;

              chat.label = 'Digite seu nome completo';
              chat.mask = 'text';

              this.exibirMensagemChat(2);
              this.exibirLoaderFullscreen = false;
            }
          },
          (err) => {
            this.cacauLoverCadastro.cpf = dado;

            chat.label = 'Digite seu nome completo';
            chat.mask = null;
            chat.inputType = 'text';

            this.exibirMensagemChat(2);
          }
        );
        break;
      case 2:
        var regexNome = new RegExp('^[a-zA-ZÀ-ú][a-zA-ZÀ-ú\\s]+$');

        if (dado.length < 5) {
          this.chatMensagens.push(this.chatMensagensBotErro[1]);
          this.irParaOFimDoChat();
          chat.value = '';
          return;
        }
        if (!regexNome.test(dado)) {
          this.chatMensagens.push(this.chatMensagensBotErro[6]);
          this.irParaOFimDoChat();
          chat.value = '';
          return;
        }

        this.cacauLoverCadastro.nome = dado;
        var nome = this.cacauLoverCadastro.nome.split(' ')[0];

        this.chatMensagensBot[4].mensagem =
          this.chatMensagensBot[4].mensagem.replace('{NOME}', nome);
        this.chatMensagensBot[9].mensagem =
          this.chatMensagensBot[9].mensagem.replace('{NOME}', nome);

        chat.mask = '(00) 00000-0000';
        chat.label = 'Digite seu celular';
        chat.inputType = 'tel';
        this.exibirMensagemChat(2);
        break;
      case 3:
        dado = '55' + dado;
        if (dado.length < 12) {
          this.chatMensagens.push(this.chatMensagensBotErro[2]);
          this.irParaOFimDoChat();
          chat.value = '';
          return;
        }

        this.cacauLoverCadastro.telefone = dado;

        chat.mask = '00/00/0000';
        chat.label = 'Digite sua data de nascimento';
        chat.inputType = 'tel';
        this.exibirMensagemChat(1);
        break;
      case 4:
        dado = (<HTMLInputElement>document.getElementById('chat')).value;
        var dadoSplit = dado.split('/');
        var data = `${dadoSplit[2]}-${dadoSplit[1]}-${dadoSplit[0]}`;

        var hj = new Date();
        var date = new Date(data);

        if (
          hj.getTime() < date.getTime() ||
          date.getFullYear() < hj.getFullYear() - 120
        ) {
          this.chatMensagens.push(this.chatMensagensBotErro[3]);
          this.irParaOFimDoChat();
          chat.value = '';
          return;
        }

        this.cacauLoverCadastro.dataNascimento = date;

        chat.label = 'Digite seu e-mail';
        chat.inputType = 'text';
        chat.mask = '';

        this.exibirMensagemChat(1);
        break;
      case 5:
        dado = dado.toLowerCase();
        let age = this.getAge(this.cacauLoverCadastro.dataNascimento);

        if (age < 65 || dado != '') {
          var regexEmail = new RegExp(
            '^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$'
          );

          if (!regexEmail.test(dado)) {
            this.chatMensagens.push(this.chatMensagensBotErro[9]);
            this.irParaOFimDoChat();
            chat.value = '';
            return;
          }
        }

        this.cacauLoverCadastro.email = dado;

        this.regConfigCadastroCacauLover = [];

        this.exibirMensagemChat(1);
        break;
      case 6:
        //var regexSenha = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\\d$@$!%*?&].{7,}$');

        var termos = (<HTMLInputElement>(
          document.getElementById('aceitaTermosChat-input')
        )).checked;
        // var comunicacao = (<HTMLInputElement>(
        //   document.getElementById('aceitaComunicacaoChat-input')
        // )).checked;

        if (!termos) {
          this.chatMensagens.push(this.chatMensagensBotErro[5]);
          this.irParaOFimDoChat();
          chat.value = '';
          return;
        }

        // if (dado.length < 6) {
        //     this.chatMensagens.push(this.chatMensagensBotErro[4]);
        //     this.irParaOFimDoChat();
        //     chat.value = "";
        //     return;
        // }

        //if (!regexSenha.test(dado)) {
        //this.chatMensagens.push(this.chatMensagensBotErro[7]);
        //this.irParaOFimDoChat();
        //chat.value = "";
        //return;
        //}

        //this.cacauLoverCadastro.senha = dado;
        //this.cacauLoverCadastro.senhaConfirmacao = dado;

        this.cacauLoverCadastro.aceiteTermo = termos;
        this.cacauLoverCadastro.enviaComunicacao = true;

        this.cacauLoverCadastro.genero = 'N';
        this.cacauLoverCadastro.queroSerLover = true;
        this.cacauLoverCadastro.origem = 6;
        this.cacauLoverCadastro.ativo = true;
        this.cacauLoverCadastro.tipoStatus = 1;

        this.regConfigCadastroCacauLover = [];

        this.exibirLoaderFullscreen = true;

        this.fidelidadeService
          .cadastrarMembro(this.cacauLoverCadastro)
          .subscribe(
            (sucesso) => {
              this.processarSucessoCadastroMembroChat(sucesso);
            },
            (error) => {
              this.processarFalhaCadastroMembroChat(error);
            }
          );
    }

    if (chat != undefined) chat.value = '';

    this.indexChat += 1;
    this.regConfigCadastroCacauLoverFooter[0].value = this.indexChat;

    if (this.indexChat == 1 || this.indexChat == 4) chat.inputmode = 'numeric';
    else chat.inputmode = 'text';
  }

  exibirMensagemChat(n: number) {
    for (let i = 0; i < n; i++) {
      this.chatMensagens.push(this.chatMensagensBot[this.indexChatBot++]);
    }
    this.irParaOFimDoChat();
  }

  irParaOFimDoChat() {
    setTimeout(() => {
      this.chatScroll.nativeElement.scrollTop =
        this.chatScroll.nativeElement.scrollHeight;
    }, 120);
  }

  processarSucessoCadastroMembroChat(response: any) {

    this.exibirLoaderFullscreen = false;

    this.regConfigCadastroCacauLoverFinalizar[0].label =
      'Crie sua senha e aproveite.';

    this.regConfigCadastroCacauLoverFinalizar[0].onClick = () => {
      this.router.navigate(['/home/login']);
      // this.AuthService.loginComSenha(this.cacauLoverCadastro.cpf, this.cacauLoverCadastro.senha).subscribe(
      //     sucesso => { this.processarSucessoLogin(sucesso) },
      //     falha => { this.processarFalhaLogin(falha) }
    };

    this.exibirMensagemChat(1);
  }

  processarFalhaCadastroMembroChat(error: any) {
    console.error('Ocorreu um erro ao cadastrar o membro', error);

    this.exibirLoaderFullscreen = false;

    this.regConfigCadastroCacauLoverFinalizar = [];

    if (error == 'Já existe um cadastro com o CPF informado') {
      this.chatMensagens.push(this.chatMensagensBotErro[11]);
    } else if (
      error == 'Apenas pessoas maiores de 18 anos podem participar do programa!'
    ) {
      this.chatMensagens.push(this.chatMensagensBotErro[12]);
    } else if (error === 'E-mail já cadastrado') {
      this.chatMensagens.push(this.chatMensagensBotErro[13]);
    } else {
      let mensagemErro = this.chatMensagensBotErro[8];
      mensagemErro.mensagem += ` (${error}) `;
      this.chatMensagens.push(mensagemErro);
    }

    this.irParaOFimDoChat();
  }

  processarSucessoCadastrarMembro(response: any) {
    this.exibirLoaderFullscreen = false;

    this.regConfigCadastroLoverCamposRodape[2].label =
      'Faça o login e aproveite.';
    this.regConfigCadastroLoverCamposRodape[0].visible = false;
    this.regConfigCadastroLoverCamposRodape[1].visible = false;

    this.regConfigCadastroLoverCamposRodape[2].onClick = () => {
      this.exibirLoaderFullscreen = true;

      this.AuthService.loginComSenha(
        this.membro.cpf,
        this.membro.senha
      ).subscribe(
        (sucesso) => {
          this.processarSucessoLogin(sucesso);
        },
        (falha) => {
          this.processarFalhaLogin(falha);
        }
      );
    };

    this.etapaAtual = this.regConfigCadastroLoverCamposRodape[0].value += 1;
    // this.regConfigCadastroLoverCamposRodape[2].onClick = () => this.router.navigate(["/"]);
  }

  processarSucessoLogin(response: any) {
    this.exibirLoaderFullscreen = false;

    this.AuthService.LocalStorage.salvarDadosLocaisUsuario(response);

    this.fidelidadeService.obterMembro().subscribe(
      sucesso => {
        this.AuthService.LocalStorage.salvarMembro(sucesso);
        this.router.navigate(['/index']);
      });
  }
  processarFalhaLogin(fail: any) {
    this.exibirLoaderFullscreen = false;
    alert('usuário e senha não coincidem!');
  }

  getAge(birthDate: Date) {
    var today = new Date();
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }
}
